import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Events from "./pages/Events";
import Contact from "./pages/Contact";
import DonatePage from "./pages/Donate";
import Team from "./pages/Team";
import BooksPage from "./pages/Books";
import AboutBhaktiTirthaSwami from "./pages/JourneyPage";
import RadhaGopinath from "./pages/RadhaGopinath";
import ServicesPage from "./pages/ServicesPage";
import BlogPage from "./pages/Blog";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/about" element={<About />} />
        <Route exact path="/event" element={<Events />} />
        <Route exact path="/contact" element={<Contact />} />
        <Route exact path="/donate" element={<DonatePage />} />
        <Route exact path="/team" element={<Team />} />
        <Route exact path="/books" element={<BooksPage />} />
        <Route exact path="/about-bhakti-tirtha-swami" element={<AboutBhaktiTirthaSwami />} />
        <Route exact path="/radhagopinath" element={<RadhaGopinath />} />
        <Route exact path="/services" element={<ServicesPage />} />
        <Route exact path="/blog" element={<BlogPage />} />
        <Route path="/blog/author/:authorId" element={<BlogPage />} />
        <Route path="/blog/author/:authorId/:articleId" element={<BlogPage />} />
        <Route exact path="*" element={<Navigate to={"/"} />} />
      </Routes>
    </BrowserRouter>
  );
}
